import checkoutFormModel from './checkoutFormModel';
const {
  formField: {
    firstName,
    email,
    document,
    address1,
    city,
    state,
    zipcode,
    country,
    useAddressForPaymentDetails,
    nameOnCard,
    cardNumber,
    cvv
  }
} = checkoutFormModel;

export default {
  [firstName.name]: '',
  [email.name]: '',
  [document.name]: '',
  [address1.name]: '',
  [city.name]: '',
  [state.name]: '',
  [zipcode.name]: '',
  [country.name]: 'BR',
  [useAddressForPaymentDetails.name]: false,
  [nameOnCard.name]: '',
  [cardNumber.name]: '',
  [cvv.name]: ''
};